// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "sitechromepublisher/" + (chunkId === 543 ? "translations" : chunkId) + "." + {"422":"4793ee1f0a2f302d46dd","543":"e6b41dcb444455cc232a"}[chunkId] + ".js";
};